import { ThemeProperties } from '../../core';

export interface IconButtonTheme {
	baseText: string;
	baseBorderRadius: string;
	baseHoverBackground: string;
	baseActiveBackground: string;
	baseFocusRingColor: string;

	interactiveTextColor: string;
	interactiveHoverBackground: string;
	interactiveActiveBackground: string;

	onDarkTextColor: string;
	onDarkHoverBackground: string;
	onDarkActiveBackground: string;

	infoTextColor: string;
	infoHoverBackground: string;
	infoActiveBackground: string;

	successTextColor: string;
	successHoverBackground: string;
	successActiveBackground: string;

	warningTextColor: string;
	warningHoverBackground: string;
	warningActiveBackground: string;

	dangerTextColor: string;
	dangerHoverBackground: string;
	dangerActiveBackground: string;

	smallPadding: string;
	smallIconSize: string;

	mediumPadding: string;
	mediumIconSize: string;

	largePadding: string;
	largeIconSize: string;
}

export const theme = new ThemeProperties('iconButton');
